function hintKey(clientId: number, deviceId: string) {
  return `tap-to-pay-phone:${clientId}:${deviceId}`;
}

/**
 * Remembers that this phone is registered for the client, so the dashboard
 * can warm the SDK up on launch without loading the terminal list. Not
 * Apple's activation status, which is always read live.
 */
export function rememberTapToPayPhone(clientId: number, deviceId: string) {
  try {
    localStorage.setItem(hintKey(clientId, deviceId), "1");
  } catch {
    // Only the warm-up depends on it.
  }
}

export function isRememberedTapToPayPhone(
  clientId: number,
  deviceId: string,
): boolean {
  try {
    return localStorage.getItem(hintKey(clientId, deviceId)) === "1";
  } catch {
    return false;
  }
}
